export const theme = {
  primary: '#00693e', // Washington green
  secondary: '#4a86e8',
  background: '#f9f9f9',
  card: '#ffffff',
  text: '#333333',
};
